/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskCategoriesList } from "../funcs/riskCategoriesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskCategoriesResult } from "../models/components/riskcategoriesresult.js";
import {
  ListRiskCategoriesRequest,
  ListRiskCategoriesSecurity,
} from "../models/operations/listriskcategories.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskCategoriesQueryData = RiskCategoriesResult;

export function prefetchRiskCategories(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskCategoriesRequest | undefined,
  security?: ListRiskCategoriesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskCategoriesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskCategoriesQuery(
  client$: GramCore,
  request?: ListRiskCategoriesRequest | undefined,
  security?: ListRiskCategoriesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RiskCategoriesQueryData>;
} {
  return {
    queryKey: queryKeyRiskCategories({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskCategoriesQueryFn(
      ctx,
    ): Promise<RiskCategoriesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskCategoriesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskCategories(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "categories", "list", parameters];
}
